import { getViewportInsets } from "@/hooks/use-viewport-insets";
import { currentFocusSurfaceBox } from "@/lib/focus/focus-surface";
import { getWindowOrigin } from "@/desktop/use-window-origin";
import { getWindowDisplayId } from "@/desktop/use-window-role";
import type { ScreenRect } from "@/lib/canvas-presentation-types";

export interface GlobalPresentationRect {
  x: number;
  y: number;
  width: number;
  height: number;
  displayId?: number | null;
}

export function currentFramePresentationSurface(
  fitToDisplay = false,
): ScreenRect {
  if (fitToDisplay) {
    // Native stamps are logical dimensions of this window's display work area.
    // Focus uses local coordinates: never add the display's global origin.
    const width = window.__DENKER_WORK_AREA_WIDTH__;
    const height = window.__DENKER_WORK_AREA_HEIGHT__;
    return {
      left: 0,
      top: 0,
      width:
        typeof width === "number" && Number.isFinite(width) && width > 0
          ? width
          : window.innerWidth,
      height:
        typeof height === "number" && Number.isFinite(height) && height > 0
          ? height
          : window.innerHeight,
    };
  }
  const surface = currentFocusSurfaceBox();
  const insets = getViewportInsets();
  return {
    left: surface.x + insets.left,
    top: surface.y + insets.top,
    width: Math.max(1, surface.width - insets.left - insets.right),
    height: Math.max(1, surface.height - insets.top - insets.bottom),
  };
}

export function localFramePresentationExclusions(
  exclusions: GlobalPresentationRect[],
): ScreenRect[] {
  const origin = getWindowOrigin();
  const displayId = getWindowDisplayId();
  return exclusions
    .filter(
      (rect) =>
        displayId == null ||
        rect.displayId == null ||
        rect.displayId === displayId,
    )
    .map((rect) => ({
      left: rect.x - origin.x,
      top: rect.y - origin.y,
      width: rect.width,
      height: rect.height,
    }));
}
